require('../../modules/es.string.starts-with');

module.exports = require('../../internals/entry-unbind')('String', 'startsWith');
